import pluraliseWord from './pluraliseWord';

export default function getNumberOfGuests({
	numberOfAdults = 0,
	numberOfChildren = 0,
	t,
}: {
	numberOfAdults: number | undefined;
	numberOfChildren: number | undefined;
	t: (arg: string) => string;
}) {
	return [
		numberOfAdults > 0 && pluraliseWord(numberOfAdults, t('adult'), t('adults')),
		numberOfChildren > 0 && pluraliseWord(numberOfChildren, t('child'), t('children')),
	]
		.filter(Boolean)
		.join(', ');
}
